import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import GalleryView from '@/components/GalleryView'
import ImageView from '@/components/ImageView'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        return {x:0,y:0}
    },
    // TODO: this will be needed for identifying scroll behavior 
    // on specific viewport resolution. currently in POC... need to
    // get critical tasks done first for launch then I can focus on this.

    // scrollBehavior (to, from, savedPosition) {
    //     if(window.outerWidth > 1200) {
    //         return new Promise((resolve, reject) => {
    //             setTimeout(() => {
    //               resolve({ x: 0, y: 400 })
    //             }, 500)
    //         })
    //     }
    // },
  routes: [
    {
      path: '/',
      component: GalleryView
    },
    {
      path: '/:gallery',
      component: GalleryView
    },
    {
      path: '/detail/:number',
      component: ImageView
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js